<template>
    <vue-basic-alert :duration="300" :closeIn="2000" ref="alert" />
    <section>
    
    <div class="register-container">
        <div class="register-form-container">
            <form id="ShopDetailForm" novalidate autocomplete="off" >
                <div class="closebtn">
                    <router-link to="/shopdashboard" class="close-btn" >X Close </router-link>
            </div>
                <div class="heading">
            <h3><b>Payment History</b></h3>
            </div>
     

            <div class="row">
                <div class="form-group col-sm-4">
                   <label for="fDate"> <b>Shop Tax Payee NIC</b>
                   </label>
                    <input type="text" name="searchnic" placeholder="" id="searchnic" class="form-control"
                        v-model="rentObj.searchnic" />
                        <p class="error-mess" v-if="errorObj.searchnicErr.length > 0">{{ errorObj.searchnicErr[0] }}</p>
              </div>
              
                  <div class="form-group col-sm-6 btnplace">
                    <input type="button" @click="handleSubmit" value="Search" class="btn " />
                    
                </div>
              
            </div>
              
            </form>
        </div>
    </div>
</section>
<div class="Shop-container">
       <div class="Shop-form-container">
           <form id="addShopsForm"  novalidate autocomplete="off">
            <h3 style="text-align:center;"><b>Shop Payments Details</b></h3>
            <!-- <p style="font-size: small;">* Click on arrears amount to update arrears, click on edit button for other detail updates.|හිඟ මුදල් යාවත්කාලීන කිරීම සඳහා එම කඩයට අදාළ හිඟ මුදල මත ක්ලික් කරන්න. අනෙකුත් කඩ විස්තර යාවත්කාලීන කිරීම සඳහා Edit button එක ක්ලික් කරන්න </p> -->
           <div class="row">
               <table id="shaptable" >
               <thead>
                   <tr>   
                       <th>Index</th>
                       <th>Taxpayee name</th>
                       <th>Taxpayee NIC</th>
                       <th>Shop Number</th>
                       <th>Shop Place</th>
                       <th>Vote</th>
                        <th>Paid Amount</th>
                       <th>Description</th>                      
                       <th>Paid Date</th>
                   </tr>
               </thead>
               <tbody>
                   <tr v-for=" (s,index) in allShopDetails" :key="index">

                    <td>{{  index + 1 }}</td>
                       <td style="text-align: left;">{{ s.shop_taxpayee  }}</td>
                       <td>{{ s.taxpayee_nic  }}</td>

                       <td>{{ s.shop_number   }}</td>
                       <td>{{  s.place }}</td>
            
                       <td>{{ s.vote  }}</td>
                       <td>{{ s.Paid_amount  }}</td>
                       <td style="text-align: left;">{{ s.description  }}</td>
                     
                       <td>{{ formattedDateOnly(s.paid_date)}}</td>
                       <!-- <td><input type="button" @click="deleteShopdetail(s.shop_details_id)" value="X" class=" btn"></td> -->
                     
                   </tr>
               </tbody>
                </table>
           <!-- <button class="fas fa-backward" @click="prevPage($event)" :disabled="currentPage === 1"></button>
             <span>{{ currentPage }} / {{ totalPages }}</span>
            <button class="fas fa-forward" @click="nextPage($event)" :disabled="currentPage === totalPages"></button> -->
           </div>
           </form>
       </div>
</div>

</template>
<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
// import { ref } from 'vue';
export default {
   
    name: "ShopPayamentHistory",
    el: '#vue-instance',
  
    data() {
        return {
            
            rentObj: { searchnic:"" },
            errorObj: { searchnicErr: []},
            marketstreets:[],
            shopnumbers:[],
            empshopvotes:[],
            theUser:[],
            // prs_code:null,
            distr: {
                address: {
                    ProviceVal: null,
                    
                   
            }
             },
             Prs: {
                praddress: {
                    DistVal: null,
                   
            }
             },
             allShopDetails:[],
             showPopup: false,
            
             selectedshop:'',
             
            showArrearsPopup:false,
            chosenshop:'',
            selectyr:"",
            selectmon:"",
            serverDate:'',
        }
    },

        created() {
            this.getDataFromSessionStorage()
           
        },
  
        computed : {
            ...mapState(["user"]),

            filteredEmpShopVotes() {
      // Filter the empshopvotes array based on your condition
      return this.empshopvotes.filter(ratehead => ratehead.subjecttype === 'shoprent');
    },
  
},


watch: {
  allShopDetails(newData) {
    this.$nextTick(() => {
    //   const table = $('#shaptable');
    //   if ($.fn.DataTable.isDataTable(table)) {
    //     table.DataTable().clear().destroy(); // clear + destroy
    //   }

      // Initialize DataTable only if there are rows
      if (newData.length) {
        this.initializeDataTable();
      }
    });
  }
},

    methods: {
        ...mapMutations(["setUser"]),
        async getDataFromSessionStorage(){
           const data = JSON.parse(sessionStorage.getItem('userData'))
           if(data){
                           this.nic = data.nic 
                           this.sabha = data.sabha
                           this.userLevel =data.userLevel
       

                       }
           let sabhaCode = this.sabha
           
           this.allShopDetails = (await axios.get('/shoppaymentswithdetails/')).data
           let empvotes = await axios.get('/subheads/'+ this.nic +"/"+sabhaCode)
           this.empshopvotes = empvotes.data
           try {
                    const response = await axios.get('/getserverdate'); // Ensure correct API route
                    this.serverDate = response.data.serverDate; // Ensure correct response key
                    console.log(response.data);
                    // this.formatcurrentDate=this.getCurrentDate(this.serverDate);
                } catch (error) {
                    console.error("Error fetching server date:", error);
                }
       },
          formattedDateOnly(dateString) {
                    let date = new Date(dateString)
                const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
         return `${year}-${month}-${day}`;
                  },
       initializeDataTable() {
            const table = $('#shaptable');
      if (!table.length) {
        console.error('Table element does not exist yet.');
        return;
      }

      if ($.fn.dataTable.isDataTable(table)) {
        table.DataTable().destroy(); // Destroy existing DataTable instance
      }
    
      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        pageLength: 25,
      lengthMenu: [10, 25, 50, 100],
      });
      const dataTableFilter = $('.dataTables_filter');
    if (dataTableFilter.length) {
        dataTableFilter.css({
        backgroundColor: '#27ae60',
        padding: '5px',
        borderRadius: '5px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            });
        }
      // Add focus/blur effects to the search input
      const searchInput = dataTableFilter.find('input');
      if (!searchInput.data('events-bound')) {
        searchInput
          .on('focus', () => {
            dataTableFilter.css('backgroundColor', '#e6f7ff'); // Brighter blue on focus
          })
          .on('blur', () => {
            dataTableFilter.css('backgroundColor', '#27ae60'); // Reset to original
          })
          .data('events-bound', true); // Mark as events bound
      }
    
},

    addZero(num) {
    
    num = num.toString();
        return '19' + num.slice(0, 5) + '0' + num.slice(5, -1);
    },
    addZeroPadding: function(cusnic) {
    // this.len= this.loginObj.nic.charAt(9).toUpperCase()
    // Check if the user input is a valid number
    // if (!isNaN(parseInt(this.cusObj.nic)) && this.cusObj.nic !== null && this.cusObj.nic.charAt(9).toUpperCase() === 'V') {
    if (!isNaN(parseInt(cusnic)) && cusnic !== null && (cusnic.charAt(9).toUpperCase() === 'V' || cusnic.charAt(9).toUpperCase() === 'X')) {
        
        this.paddedNum = this.addZero(cusnic);
    
    }else{
        this.paddedNum=parseInt(cusnic);
    }
    return this.paddedNum
    },


            resetCheckErr: function () {
           
            this.errorObj.searchnicErr=[];
           
        },
        resetObjects: function(){
            
            this.rentObj.searchnic="";
       
        },
        checkEmptyErr: function () {
            for (var typeErr in this.errorObj) {
                if (this.errorObj[typeErr].length != 0) {
                    return false;
                }
            }
            return true;
        },
         checkForm: function () {
            this.resetCheckErr();

            if (!this.rentObj.searchnic) {
                this.errorObj.searchnicErr.push("NIC required");
            }
            

           
        },
     
    //    async handleSubmit(e) {
    //              if (!this.checkEmptyErr()) {
    //                 e.preventDefault();
    //             } else {
    //             let Nic12 = this.addZeroPadding(this.rentObj.searchnic); 
    //              this.allShopDetails = (await axios.get('/shoppaymentbynic/'+Nic12)).data
    //              if (!this.allShopDetails || this.allShopDetails.length === 0) {
    //                 this.$refs.alert.showAlert('error', 'No Record Found');
    //                 this.allShopDetails = []; // Ensure table shows "No records found"
    //                 }

    //             }
    //     }
        async handleSubmit(e) {
            e.preventDefault();

            this.checkForm(); // populate errors

            if (!this.checkEmptyErr()) return; // stop if errors

            let Nic12 = this.addZeroPadding(this.rentObj.searchnic); 
            this.allShopDetails = (await axios.get('/shoppaymentbynic/' + Nic12)).data;

            if (!this.allShopDetails || this.allShopDetails.length === 0) {
                this.$refs.alert.showAlert('error', 'No Record Found');
                this.allShopDetails = []; // trigger table reset safely
            }
        }

        
      
    },
    components: {
        VueBasicAlert
    }
}

</script>





<style scoped>
.closebtn{
    align-content: baseline;
}
.close-btn {
/* align-items: right; */
background-color:rgb(121, 23, 12);
border: none;
font-size: 15px;
font-weight: bold;
cursor: pointer;
color: #f8f4f4;
transition: color 0.3s ease, transform 0.2s ease;
padding: 8px;
border-radius: 8px;
width:6%;
height: 4%;
text-align: center;
}
.register-container {
    padding: 1rem 1%;
   
}

.register-container .register-form-container {
    background: #fff;

}

.register-container .register-form-container form {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
    /* max-width: 98rem; */
    width: 100%;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
    border: 0.1rem solid rgba(0, 0, 0, 0.2);
    padding: 2rem;
    border-radius: 0.5rem;
    animation: fadeUp 0.4s linear;
}

.register-container .register-form-container form h3 {
    padding-bottom: 0.5rem;
    font-size: 1.9rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: center;
    
}

.register-container .register-form-container form .form-control {
    margin: 0.7rem 0;
    border-radius: 0.5rem;
    background: #f7f7f7;
    /* padding: 2rem 1.2rem; */
    font-size: 1.5rem;
    color: #130f40;
    text-transform: none;
    width: 100%;
    border: margin-bottom; 
}

.register-container .register-form-container form .form-control1 {
    margin: 0.7rem 0;
    border-radius: 0.5rem;
    background: #f7f7f7;
    /* padding: 2rem 1.2rem; */
    font-size: 1.5rem;
    color: #130f40;
    text-transform: none;
    width: 40%;
    border: none;
    padding-bottom: 0.5rem;
}
.register-container .register-form-container form .form-radio {
    margin: 2rem 0%;
    border-radius: 0.5rem;
    background: #f7f7f7;
   padding-bottom: 1rem;
    font-size: 10rem;
    color: #130f40;

    width: 10%;
    border: none;
    margin-left: 10%;
}
.register-container .register-form-container form label {
    font-size: 1.5rem;
    margin: 0;
    padding: 0;
}

.register-container .register-form-container form span {
    font-size: 25px;
    /* padding-left: 5px;
    padding-right: 40px; */
    text-align: center;
    color: #620a0a;

}

.register-container .register-form-container form .btn {
    margin: 1rem 0;
    width: 30%;
    text-align: center;
    align-items: center;
    /* background: #620a0a; */
    background-color : #5a0303;

    
}
.btnplace{
   padding-top: 1.4rem;
   padding-left: 3rem;

}

.register-container .register-form-container form p {
    padding-top: 0.75rem;
    font-size: 1rem;
    color: #666;
    margin: 0;
}

.register-container .register-form-container form p a {
    color: #27ae60;
}

.register-container .register-form-container form p a:hover {
    color: #130f40;
    text-decoration: underline;
}

.register-container .register-form-container form .form-group  {
    margin: 0;
}

.register-container .register-form-container form .form-group  .error-mess {
    font-size: 1rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 0;
    padding: 0;
    width: 90%;

} 
.register-container .register-form-container form .hide {
    display: none;

} 
/* for second container */
.Shop-container {
   background-color: #ffffff09;
   /* height: 50vh; */
   padding: 1rem 1%;
   font-size: 16px;
   min-height: 45rem;
}



/* ongoing */
.Shop-container .Shop-form-container {
   background: #fff;
   width: 100% !important;
   
}

.Shop-container .Shop-form-container form {
   /* position: relative;
   left: 40%;
   transform: translate(-50%, 0%); */
   /* max-width: 70rem; */
   width: 100%;
   box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
   border: 0.1rem solid rgba(0, 0, 0, 0.2);
   padding: 3rem;
   border-radius: 0.5rem;
   animation: fadeUp 0.4s linear;
   
}

.Shop-container .Shop-form-container form h3 {
   padding-bottom: 1rem;
   font-size: 2rem;
   text-transform: uppercase;
   color: #130f40;
   margin: 0;
}

.Shop-container .Shop-form-container form .form-control {
    margin: 0.7rem 0;
   border-radius: 0.5rem;
   background: #f7f7f7;
   /* padding: 2rem 1.2rem; */
    font-size: 1.3rem; 
   color: #130f40;
   text-transform: none;
   width: 100%;
   border: margin-bottom; 
} 

.Shop-container .Shop-form-container form label {
    font-size: 1.2rem;
   margin: 0;
   padding: 0;
   float:left;
}

.Shop-container .Shop-form-container form span {
   font-size: 18px;
   padding-left: 5px;
   padding-right: 40px;
}

.Shop-container .Shop-form-container form .btn {
   margin: 1rem 0;
   width: 100%;
   text-align: center;
   font-size: small;
   background-color : #af74a7;
    height: 3rem;
  
   
}
/* .Shop-container .Shop-form-container form .table {
   margin: 1rem 0;
   width: 100%;
   text-align: center;
   font-size: small;
   background-color : #e9e4e9;
    height: 3rem;
   
} */
.Shop-container .Shop-form-container form .Addbtn {
   /* margin: 1rem 0; */
   width: 5rem;
   /* height: 2rem; */
   /* text-align: center; */
   /* background-color : #af74a7; */
   /* vertical-align: bottom; */
   /* align-items: bottom; */
   padding-top: 1.9rem;
   padding-left: 3rem;
   
}

.Shop-container .Shop-form-container form p {
   padding-top: 1rem;
   font-size: 1.5rem;
   color: rgb(22, 21, 21);
   margin: 0;
}

.Shop-container .Shop-form-container form p a {
   color: #27ae60;
}

.Shop-container .Shop-form-container form p a:hover {
   color: #130f40;
   text-decoration: underline;
}

.Shop-container .Shop-form-container form .form-group {
   margin: 0;
}

.Shop-container .Shop-form-container form .form-group .error-mess {
   font-size: 1.5rem;
   position: relative;
   color: rgb(243, 47, 47);
   margin: 0;
   padding: 2rem 1.2rem;
}
/* .project-list>tbody>tr>td {
   padding: 12px 8px;
}

.project-list>tbody>tr>td .avatar {
   width: 22px;
   border: 1px solid #CCC;
} */
/* [popup] */
.popup-button {
      padding: 10px 20px;
      background-color: #007bff;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
  }

  .modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
  }

  .modal-content {
      background-color: white;
      padding: 5px;
      border-radius: 1px;
      /* max-width: 500px; */
      width: 60%;
      position: relative;
  }

  .close x {
      position: absolute;
      top: 10px;
      right: 10px;
      padding: 5px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 18px;
      color: #555;
  }

  .close-x:hover {
      color: #ff0000;
      /* Change to your desired hover color */
  }


  .modal-header {
      padding-bottom: 2px;
      border-bottom: 1px solid #ccc;
  }

  .modal-body {
      /* padding: 10px 20px 20px 20px; */
      padding-left: 5%; 

  }
  .model-group {
      padding: 10px ;
      /* padding-left: 10%;
      padding-right: 10%;
      padding-bottom: 10%; */
      /* margin: 10px; */
      /* justify-content: left; */
      margin-right: 10px;
  }
  .modal-body.model-group .error-mess {
    font-size: 1rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 10%;
    padding: 0;
    width: 90%;

} 
.modal-body.row {
    display: flex;
    margin: 10%;
  }
  .modal-footer {
      padding-top: 5px;
      border-top: 1px solid #ccc;
      display: flex;
      justify-content: flex-end;
  }

  .close-button,
  .save-button {
      padding: 5px 10px;
      border: none;
      cursor: pointer;
      font-weight: bold;
      border-radius: 4px;
      transition: background-color 0.3s ease;
  }

  .close-button {
      background-color: #f44336;
      color: white;
  }

  .save-button {
      background-color: #4CAF50;
      color: white;
      margin-left: 5px;
  }

  .close-button:hover {
      background-color: #d32f2f;
  }

  .save-button:hover {
      background-color: #45a049;
  }
  /* 2 */
  .modal-body2 {
      /* padding: 10px 20px 20px 20px; */
      padding-left:1.0rem; 

  }
  .modal-content2 {
      background-color: white;
      padding: 5px;
      border-radius: 1px;
      /* max-width: 500px; */
      width: 30%;
      position: relative;
  }
  .model-group2 {
      /* padding: 10px ; */
      padding-left: 10%;
      padding-right: 10%;
      padding-bottom: 10%; 
      /* margin: 10px; */
      justify-content:center;
      margin-right: 10px;
  }
  .modal-footer2 {
      padding-top: 5px;
      border-top: 1px solid #ccc;
      display: flex;
      justify-content: flex-end;
  }
  .close-x2 {
      /* position: absolute; */
      top: 5px;
      right: 5px;
      left: 5px;
      padding: 5px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 15px;
      color: #555;
  }
  .modal-body2 .model-group2 .error-mess {
    font-size: 1rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 10%;
    padding: 0;
    width: 90%;

} 
#shaptable {
   width: 100%; 
  text-align: center; 
  font-size: 1.2rem;; 
  border-width: 1px; 
  border-style: solid; 
  border-color: #130f40; 
  border-collapse: collapse; 
  /* margin-left: auto;  */
  /* margin-right: auto; */
  /* table-layout: fixed;  */
}

#shaptable thead  th {
  background-color: #f4f4f4;
  color: #333;
  font-weight: bold;
  /* padding: 10px; */
  /* width: auto; */
  font-size: 1.2rem; 
  text-align: center;
}

#shaptable tbody tr {
  background-color: #fff;
}

#shaptable tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>
